import { isProduction } from "../config/env.ts";
import { OrgSubscriptionPlan } from "../models/billing.ts";

export const oneMonthFreeFiboCouponId = isProduction() ? "Zs3tqCC6" : "qkZkjPpo";
export const twentyDollarCreditCouponId = isProduction() ? "piLlHLdD" : "vSxxn0rD";

export const SubscriptionIntervalMapping: { [key: string]: string } = {
	month: "Monthly",
};

export enum ORG_BLOCK_REASONS {
	PASSED_FREE_LIMITS = "PASSED_FREE_LIMITS",
	BLOCKED_BY_ADMIN = "BLOCKED_BY_ADMIN",
	BLOCKED_BY_ORG_ADMIN = "BLOCKED_BY_ORG_ADMIN",
	OTHER = "OTHER",
}

export enum ORG_SUBSCRIPTION_STATUSES {
	ACTIVE = "active",
	PAST_DUE = "past_due",
	INCOMPLETE = "incomplete",
	INCOMPLETE_EXPIRED = "incomplete_expired",
	TRIALING = "trialing",
	CANCELED = "canceled",
	UNPAID = "unpaid",
	PAUSED = "paused",
}

export const ORG_SUBSCRIPTION_PLANS: {
	[key: string]: OrgSubscriptionPlan;
} = {
	free: {
		name: "free",
		displayName: "Free",
		selfService: false,
	},
	starter: {
		name: "starter",
		displayName: "Self Service",
		selfService: true,
		priceIds: isProduction()
			? [
					"price_1Paw0sHW6TJCmNekeykY3829",
					"price_1SMovtHW6TJCmNekbdtnTHPw",
					"price_1SMotyHW6TJCmNekuY6rAtmJ",
					"price_1SMotCHW6TJCmNekdZMmqTcE",
					"price_1Sd6YwHW6TJCmNek97UOhiiP",
					"price_1SX13lHW6TJCmNek3myoCiQT",
					"price_1SX14YHW6TJCmNekHW6n77UD",
					"price_1StUD2HW6TJCmNekbrokO5iR",
					"price_1T6AoZHW6TJCmNekB2wmuwnx",
				]
			: [
					"price_1PdC5cHW6TJCmNekCehbNZOm",
					"price_1SMT0pHW6TJCmNekKl07hjxF",
					"price_1SMT0CHW6TJCmNekiTZv0Qk8",
					"price_1SMnrcHW6TJCmNekIu5R3mIk",
					"price_1SMnwVHW6TJCmNekpLu3UkpY",
					"price_1SX0vXHW6TJCmNekvJvepJb5",
					"price_1SX0wMHW6TJCmNeklOxPrVji",
				],
		termsAndConditionsLink:
			"https://pages.bria.ai/hubfs/Terms%20and%20Conditions/Bria%20AI%20Online%20Terms%20and%20Conditions%20(June%202024)%20v1.pdf",
	},
	pro: {
		name: "pro",
		displayName: "Pro",
		selfService: false,
	},
	enterprise: {
		name: "enterprise",
		displayName: "Enterprise",
		selfService: false,
	},
	business: {
		name: "business",
		displayName: "Business",
		selfService: false,
	},
	custom: {
		name: "custom",
		displayName: "Custom",
		selfService: true,
	},
	aws: {
		name: "aws",
		displayName: "AWS",
		selfService: true,
	},
	rmbgApi: {
		name: "rmbg api",
		displayName: "RMBG API",
		selfService: true,
	},
	rmbgModel: {
		name: "rmbg model",
		displayName: "RMBG Model",
		selfService: true,
	},
};

export enum ORG_STATUSES {
	active = "active",
	PASSED_FREE_LIMITS = "passedFreeLimits",
	BLOCKED_BY_ADMIN = "blockedByAdmin",
	BLOCKED_BY_ORG_ADMIN = "blockedByOrgAdmin",
}

export type IOrgStatusKey = keyof typeof ORG_STATUSES;

export enum RelatedOrgSubscriptionTypes {
	free = "free",
	payAsYouGo = "payAsYouGo",
	business = "business",
	custom = "custom",
}

export const TRIAL_CHANGE_EFFECTIVE_DATE = new Date("2026-03-25T00:00:00Z");
